export const StepHeader = ({ current }) => {
  return (
    <div className="step-header">
      <div className={`step-item ${current >= 1 ? "active" : ""}`}>
        <div className="step-circle">{current > 1 ? "✓" : "1"}</div>
        <span>Basic Details</span>
      </div>

      <div className="step-line" />

      <div className={`step-item ${current >= 2 ? "active" : ""}`}>
        <div className="step-circle">{current > 2 ? "✓" : "2"}</div>
        <span>Professional Details</span>
      </div>

      <div className="step-line" />

      <div className={`step-item ${current >= 3 ? "active" : ""}`}>
        <div className="step-circle">{current > 3 ? "✓" : "3"}</div>
        <span>Slot Management</span>
      </div>

      {/* <div className="step-line" /> */}

      {/* <div className={`step-item ${current >= 4 ? "active" : ""}`}>
        <div className="step-circle">{current > 4 ? "✓" : "4"}</div>
        <span>Preview</span>
      </div> */}
    </div>
  );
};
